import React from "react";
import { Trans } from "@lingui/macro";
import { Button } from "../../../../UI/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { InputText } from "../../../../UI/InputText/InputText";
import { useInputChange } from "../../../../../hooks/useInputChange";
import { selectFilters } from "../../../../../model/dashboardEdmProducts/selectors";
import { typeProductsFilters } from "../../../../../model/dashboardEdmProducts/dEdmProductsReducer";
import { dEdmProductsSetFiltersAC } from "../../../../../model/dashboardEdmProducts/dEdmProductsActionCreators";
import {
  NULL_VALUE,
  SelectBox,
  typeValuesListItem,
} from "../../../../UI/SelectBox/SelectBox";

export type typeDProductsFilters = {
  setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>;
  setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>;
};

export const DProductsFilters: React.FC<typeDProductsFilters> = ({
  setOpenFilterBar,
  setIsActiveFilters,
}) => {
  const dispatch = useDispatch();

  const filters = useSelector(selectFilters);

  const {
    value: barcodeValue,
    setValue: setBarcodeValue,
    changeValueHandler: onChangeBarcodeValue,
  } = useInputChange(filters.barcode ? filters.barcode : "");

  const MARKED = "marked";
  const NOT_MARKED = "notMarked";
  const markedValueList: typeValuesListItem[] = [
    { id: MARKED, name: <Trans>Marked</Trans> },
    { id: NOT_MARKED, name: <Trans>Not marked</Trans> },
  ];

  const [markedValue, setMarkedValue] = React.useState<string>(
    filters.marked === null
      ? NULL_VALUE.id
      : filters.marked
        ? MARKED
        : NOT_MARKED,
  );

  const checkIsChangedFiltersHandler = (
    newFilters: typeProductsFilters,
  ): boolean => {
    return !(
      newFilters.marked === filters.marked &&
      newFilters.barcode === filters.barcode
    );
  };

  const onSubmitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const newFilters: typeProductsFilters = {
      marked:
        markedValue === MARKED
          ? true
          : markedValue === NOT_MARKED
            ? false
            : null,
      barcode: barcodeValue.trim() ? barcodeValue.trim() : null,
    };

    if (checkIsChangedFiltersHandler(newFilters)) {
      dispatch(dEdmProductsSetFiltersAC(newFilters));

      setIsActiveFilters(true);
    }

    setOpenFilterBar(false);
  };

  const onRestoreHandler = () => {
    setBarcodeValue("");

    setMarkedValue(NULL_VALUE.id);

    setIsActiveFilters(false);

    dispatch(
      dEdmProductsSetFiltersAC({
        marked: null,
        barcode: null,
      }),
    );
  };

  return (
    <>
      <form onSubmit={(e) => onSubmitHandler(e)}>
        <div className="flex flex-col gap-4">
          <div>
            <InputText
              id={"barcode"}
              maxLength={14}
              value={barcodeValue}
              label={<Trans>Barcode</Trans>}
              onChange={onChangeBarcodeValue}
            />
          </div>

          <div>
            <SelectBox
              valueId={markedValue}
              setIdValue={setMarkedValue}
              valuesList={markedValueList}
              label={<Trans>Is marked products</Trans>}
            />
          </div>

          <div className="flex gap-4 mt-4">
            <Button
              type="button"
              secondary={true}
              buttonClassName="w-full"
              onClick={onRestoreHandler}
              label={<Trans>Clear</Trans>}
            />
            <Button
              type="submit"
              buttonClassName="w-full"
              label={<Trans>Apply</Trans>}
            />
          </div>
        </div>
      </form>
    </>
  );
};
